export class SlotBookings {
    SlotDate: Date;
    ID: number;
    Count: number;
    IsHoliday: number;
    VillageID: number;
    CustomerID: number;
    BookingReferenceNo: string;
    /// messages
    CurrentOTP: string;
    IsInValidOtp: boolean;
    EmailId: string;
    MobileNo: string;
    SubRegisterOffice: string;
    IsOtpMessage: boolean;
     IsBokkingMessage: boolean;
    OtpText: string;
    captchaError: boolean;
    Message:string;
    BlockName:string;
    FlatNo:string;
    FloorName:string;
    Name:string;
    VillageName:string;
    Status:Number;
    ApplicationNO:string;
    ApprovedName: string;
    Reason: string;
}

